class CCBDto {
	cpf_signature = '';
	transaction = '';
}

export default CCBDto;
